import { render, staticRenderFns } from "./GModal.vue?vue&type=template&id=6e2b59b2&scoped=true&"
import script from "./GModal.vue?vue&type=script&lang=js&"
export * from "./GModal.vue?vue&type=script&lang=js&"
import style0 from "./GModal.vue?vue&type=style&index=0&id=6e2b59b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b59b2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider,VIcon,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e2b59b2')) {
      api.createRecord('6e2b59b2', component.options)
    } else {
      api.reload('6e2b59b2', component.options)
    }
    module.hot.accept("./GModal.vue?vue&type=template&id=6e2b59b2&scoped=true&", function () {
      api.rerender('6e2b59b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/GModal.vue"
export default component.exports